import { ButtonBase } from '@mui/material';
import cx from 'classnames';

import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import { getButtonLinkProps } from '@openclassrooms/routing';

interface Props {
  subTitle: string;
  path: string;
  children?: string;
  isActive?: boolean;
  onClick?: () => void;
  'data-event'?: string;
  'data-testid'?: string;
}

const RootBaseButton = styled(ButtonBase)(({ theme: { radius, palette, breakpoints } }) => {
  const baseColor = palette.background.paper;
  const unselectedHoverColor = palette.menu.background.unselected.hover;
  const selectedColor = palette.menu.background.selected.enabled;
  const selectedHoverColor = palette.menu.background.selected.hover;

  return {
    '--background-color': baseColor,
    '--icon-background-color': selectedColor,
    maxWidth: 336,
    width: '100%',
    justifyContent: 'flex-start',
    borderRadius: radius.banner,
    background: 'var(--background-color)',
    '&:hover': {
      '--background-color': unselectedHoverColor,
      '--icon-background-color': baseColor,
      color: palette.text.primary,
    },
    '&.isActive': {
      '--background-color': selectedColor,
      '--icon-background-color': baseColor,
      color: palette.text.primary,
      '&:hover': {
        '--background-color': selectedHoverColor,
      },
    },
    '&:focus-visible': {
      outline: `2px solid ${palette.brand.primary}`,
    },
    [breakpoints.up('lg')]: {
      width: 336,
    },
  };
}) as typeof ButtonBase;

const Inner = styled('div')(({ theme: { spacing } }) => ({ padding: spacing(1, 2) }));

const noop = () => {};

export default function HeaderDropDownItem({
  isActive,
  subTitle,
  path,
  children,
  onClick = noop,
  'data-event': dataEvent,
}: Props) {
  const linkProps = getButtonLinkProps(path);

  return (
    <RootBaseButton
      {...linkProps}
      className={cx({ isActive })}
      data-event={dataEvent}
      onClick={onClick}
    >
      <Inner>
        <Typography variant="h5" component="div">
          {children}
        </Typography>
        <Typography variant="caption" color="textPrimary">
          {subTitle}
        </Typography>
      </Inner>
    </RootBaseButton>
  );
}
